export var Roles;
(function (Roles) {
    Roles["User"] = "User";
    Roles["SuperUser"] = "SuperUser";
    Roles["Admin"] = "Admin";
    Roles["SuperAdmin"] = "SuperAdmin";
})(Roles || (Roles = {}));
export var OwnershipFilterTypes;
(function (OwnershipFilterTypes) {
    OwnershipFilterTypes["All"] = "All";
    OwnershipFilterTypes["Own"] = "Own";
})(OwnershipFilterTypes || (OwnershipFilterTypes = {}));
export const adminRoles = [Roles.Admin, Roles.SuperAdmin];
